import AppShell from 'components/shell/AppShell';
import { checkAuthenticationSuperAdmin } from 'helpers/lib';

const AdminLayout = (props) => {
  const role = checkAuthenticationSuperAdmin() ? 'superadmin' : 'admin';

  return (
    <AppShell role={role} isLoading={props.isLoading}>
      {props.children}
    </AppShell>
  );
};

export default AdminLayout;
